import React, { useState } from "react";
import { api, formatApiError } from "../lib/api";
import { useLanguage } from "../contexts/LanguageContext";
import { T } from "../i18n/strings";
import { Mail, MapPin } from "lucide-react";

export default function Contact() {
  const { lang } = useLanguage();
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/contact", form);
      setSent(true);
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12 lg:py-16 grid grid-cols-1 lg:grid-cols-5 gap-12" data-testid="contact-page">
      <div className="lg:col-span-2">
        <div className="pw-eyebrow">{T.labels.contact[lang]}</div>
        <h1 className="font-serif-display text-4xl lg:text-5xl font-bold text-[#081422] mt-2">
          {T.labels.contactHeadline[lang]}
        </h1>
        <p className="font-serif-body text-lg text-[#475569] mt-4 leading-relaxed">
          {T.labels.contactBlurb[lang]}
        </p>
        <div className="mt-8 space-y-4 font-sans-ui text-sm">
          <div className="flex items-center gap-3"><Mail size={16} className="text-[#C5A059]" /> editors@politicalwindow.example</div>
          <div className="flex items-center gap-3"><MapPin size={16} className="text-[#C5A059]" /> Brasília · Washington, D.C.</div>
        </div>
      </div>
      <form onSubmit={submit} className="lg:col-span-3 pw-window-frame p-8 space-y-4">
        <div>
          <label className="pw-eyebrow block mb-2">{T.labels.name[lang]}</label>
          <input required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} className="pw-input" data-testid="contact-name" />
        </div>
        <div>
          <label className="pw-eyebrow block mb-2">{T.labels.email[lang]}</label>
          <input type="email" required value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} className="pw-input" data-testid="contact-email" />
        </div>
        <div>
          <label className="pw-eyebrow block mb-2">{T.labels.subject[lang]}</label>
          <input value={form.subject} onChange={(e) => setForm({...form, subject: e.target.value})} className="pw-input" data-testid="contact-subject" />
        </div>
        <div>
          <label className="pw-eyebrow block mb-2">{T.labels.message[lang]}</label>
          <textarea required value={form.message} onChange={(e) => setForm({...form, message: e.target.value})} className="pw-input pw-textarea" data-testid="contact-message" />
        </div>
        {error && <div className="text-[#8B0000] font-mono-meta text-xs uppercase tracking-widest" data-testid="contact-error">{error}</div>}
        {sent && <div className="text-[#0F2137] font-mono-meta text-xs uppercase tracking-widest bg-[#F7F2E6] p-3" data-testid="contact-success">{T.labels.sent[lang]}</div>}
        <button type="submit" disabled={loading} className="pw-btn w-full justify-center" data-testid="contact-submit">
          {loading ? "..." : T.labels.submit[lang]}
        </button>
      </form>
    </div>
  );
}
